<template>
  <div class="background">
    <div class="dashboard-wrapper">
      <alerts-list></alerts-list>
      <div class="blocks-container">
        <notifications-history
          class="notifications-history"
          smallVersion
        >
          <div slot="title">Notifications History</div>
        </notifications-history>
        <login-history smallVersion>
          <div slot="title">Recent Logins</div>
        </login-history>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationsHistory from 'Common/NotificationsHistory';
import LoginHistory from 'Common/LoginHistory';
import AlertsList from 'Common/alertsList';

export default {
  components: {
    AlertsList,
    NotificationsHistory,
    LoginHistory,
  },
};
</script>

<style lang="scss" scoped>
  .blocks-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .container {
    margin: 0 0 60px !important;
  }
  .login-history {
    width: 550px;
    margin-left: 10px;
  }
  .background {
    @include background;
  }
  .dashboard-wrapper {
    @include container;
    padding: 0 30px;
    .notifications-history {
      margin: 0;
    }
    .recent-login__container {
      float: right;
      padding: 27px 0 0;
      @include clearfix();
      .head-title {
        margin-bottom: 30px;
      }
    }
  }
  @media only screen and (max-width : 1250px) {
    .dashboard-wrapper {
      padding: 0 10px;
    }
  }
  @media only screen and (max-width : 1024px) {
    .blocks-container {
      flex-wrap: wrap;
      justify-content: center;
    }
    .login-history {
      margin-left: 0;
      margin-top: 60px;
    }
  }
  @media only screen and (max-width : 570px) {
    .login-history {
      min-width: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue